import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/ui/Toast";
import { setMutationErrorNotifier } from "@/lib/mutationErrorBridge";

/**
 * Branche le MutationCache de React Query sur le ToastProvider.
 *
 * Ne rend rien : il ne sert qu'à enregistrer le notifier au montage. À monter
 * une seule fois, DANS le ToastProvider (cf. main.tsx).
 *
 * Les messages d'erreur de la base sont déjà rédigés en français et explicites
 * (« Publication impossible — champs manquants : prix, au moins 1 photo »,
 * « Aucun champ autorisé à la modification pour le rôle X »), on les affiche
 * donc tels quels derrière un préfixe générique. L'application est interne
 * (staff uniquement), le risque de fuite d'information par le message est
 * assumé — et vaut très largement mieux qu'un échec silencieux.
 */
export function MutationErrorToaster() {
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    setMutationErrorNotifier((raw) => {
      toast.error(t("common.saveErrorDetail", { message: raw }));
    });
    return () => setMutationErrorNotifier(null);
  }, [toast, t]);

  return null;
}
